import React, { FunctionComponent, useState } from 'react';
import styles from './CheckBox.module.scss';
import { CheckBoxIschecked, HelpIcon } from 'app/assets/images/icons';
import { _t } from 'app/utils/i18n';

interface Props {
  label?: string;
  checked?: boolean;
  onChange?: (e: any) => void;
  help?: boolean;
  htmlFor: string;
  name?: string;
}
const CheckBox: FunctionComponent<Props> = ({
  label,
  checked,
  onChange,
  help,
  htmlFor = 'check',
  name,
}) => {
  return (
    <div className={styles.CheckBox}>
      <div className={styles.CheckBoxHolder}>
        <label htmlFor={htmlFor} className={styles.CheckBoxHolder__Label}>
          <input
            id={htmlFor}
            type="checkbox"
            name={name ? name : 'checkBox'}
            checked={checked}
            onChange={onChange}
          />
          <p className={styles.checkboxParentP}>
            <CheckBoxIschecked /> {/**Icon */}
          </p>
          {label && (
            <span data-testid="label-holder">{_t(`login:${label} `)}</span>
          )}
        </label>
      </div>
      {help && (
        <i data-testid="help-icon-holder">
          <HelpIcon />
        </i>
      )}
    </div>
  );
};
export default CheckBox;
